/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Advies_GebruikenInputs */

const nl_planning_vakanties_advies_gebruiken = /** @type {(inputs: Planning_Vakanties_Advies_GebruikenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advies gebruiken`)
};

/**

* @param {Planning_Vakanties_Advies_GebruikenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_advies_gebruiken = /** @type {((inputs?: Planning_Vakanties_Advies_GebruikenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Advies_GebruikenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_advies_gebruiken(inputs)
});
export { planning_vakanties_advies_gebruiken as "planning.vakanties.advies_gebruiken" }